import { useSchoolStore } from "@stores/school.store";

export const Footer = () => {
  const { name, moto } = useSchoolStore((state) => state);

  const splitName = (name: string) => {
    if (!name) return { main: "Sistem Informasi Pondok", extra: "" };

    const match = name.match(/^(.+?)\s*(\(.+\))$/);

    return match
      ? { main: match[1], extra: match[2] }
      : { main: name, extra: "" };
  };
  const { main, extra } = splitName(
    name ?? "Baitul Ilmi (Islamic Boarding School)"
  );
  return (
    <>
      <div className="footer mt-4">
        <div className="footer card card-style mx-0 mb-0">
          <span className="footer-title !tw-text-lg pt-4">{main}</span>
          <span className="footer-title !tw-text-sm mb-3">{extra}</span>
          <p className="boxed-text-l !tw-text-sm mb-3">
            {moto ?? "Moto Pondok"}
          </p>
          {/* <p className="footer-copyright mb-1">
            Copyright &copy; Sipond{" "}
            <span id="copyright-year">{new Date().getFullYear()}</span>. All
            Rights Reserved.
          </p> */}
        </div>
        {/* <div className="footer-card card bg-20" style={{ height: "230px" }}>
          <div className="card-overlay bg-highlight opacity-90"></div>
        </div> */}
      </div>
    </>
  );
};
